module.exports = __webpack_public_path__ + "media/assets/file_upload-5c3be8c2afea917f92656254b6aec942.svg";